import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv } from "./ThemedShimmer";

const ProfilePageSkeleton = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`profile-skeleton ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingProfile")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingProfile")}</span>

      <div className="position-relative">
        <ShimmerDiv height={60} width="100%" rounded={6} />

        <div
          style={{
            position: "absolute",
            left: "25px",
            bottom: "-45px",
          }}
        >
          <ShimmerDiv height={90} width={90} rounded={50} />
        </div>
      </div>

      <div className="bg-white p-4 pt-5 border rounded">
        <ShimmerDiv height={30} width="250px" rounded={4} />
        <ShimmerDiv height={15} width="150px" rounded={4} className="mt-2" />
        <ShimmerDiv height={15} width="300px" rounded={4} className="mt-2" />
        <ShimmerDiv height={15} width="180px" rounded={4} className="mt-2" />

        <div className="d-flex justify-content-end gap-5 mt-4">
          {[1, 2, 3, 4].map((item) => (
            <div key={item}>
              <ShimmerDiv height={12} width={60} rounded={4} />
              <ShimmerDiv height={18} width={25} rounded={4} className="mt-2" />
            </div>
          ))}
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-lg-8">
          <div className="bg-white p-3 rounded border">
            <ShimmerDiv height={25} width="200px" rounded={4} />
            <ShimmerDiv height={10} width="100%" rounded={20} className="mt-3" />
            <ShimmerDiv height={18} width="150px" rounded={4} className="mt-3" />
          </div>

          <div className="bg-white p-3 rounded border mt-3">
            <ShimmerDiv height={18} width="100%" rounded={4} />
            <ShimmerDiv height={18} width="80%" rounded={4} className="mt-2" />
          </div>

          <div className="bg-white p-3 rounded border mt-3">
            <ShimmerDiv height={25} width="180px" rounded={4} />

            {[1, 2, 3, 4, 5].map((item) => (
              <div
                key={item}
                className="d-flex justify-content-between align-items-center py-3 border-bottom"
              >
                <div>
                  <ShimmerDiv height={12} width={100} rounded={4} />
                  <ShimmerDiv height={18} width={180} rounded={4} className="mt-2" />
                </div>
                <ShimmerDiv height={18} width={18} rounded={4} />
              </div>
            ))}
          </div>
        </div>

        <div className="col-lg-4">
          <div className="bg-white p-2 border rounded">
            <ShimmerDiv height={300} width="100%" rounded={6} />
            <ShimmerDiv height={18} width="120px" rounded={4} className="mx-auto mt-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePageSkeleton;
